import { css } from 'styled-components';

export const textBlock = css`
    padding: 20px 24px 44px 24px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-height: 100%;
    overflow: hidden;
    > p {
        margin: 10px 0 0 0;
    }
    h4 {
        font-weight: 600;
        overflow-wrap: break-word;
    }
`;

export const redSmallDateStyling = css`
    color: #e60000;
    font-size: 14px;
    padding-bottom: 15px;
`;

export const iconsAndTextContainer = css`
    padding-bottom: 4px;
`;

export const iconTextStyle = css`
    display: grid;
    grid-auto-flow: column;
    justify-content: flex-start;
    padding: 0 24px;
    margin-bottom: 18px;
    svg {
        margin-right: 16px;
    }
    span {
        display: block;
        height: 100%;
        margin-top: -1px;
        overflow-wrap: anywhere;
    }
`;
